import { jsx } from "@emotion/react/jsx-runtime";
import { useThemeProps } from "@wsui/base";
import PostsModuleCardItem from "./PostsModuleCardItem.mjs";
import PostsModuleTeaserItem from "./PostsModuleTeaserItem.mjs";
import PostsModuleButtonItem from "./PostsModuleButtonItem.mjs";
function defaultVariantMapping(_ref) {
  let {
    variant
  } = _ref;
  switch (variant) {
    case "card":
    default:
      return PostsModuleCardItem;
    case "teaser":
      return PostsModuleTeaserItem;
    case "button":
      return PostsModuleButtonItem;
  }
}
function PostsModuleItem(props) {
  props = useThemeProps({
    props,
    name: "MunicipioPostsModuleItem"
  });
  let {
    item,
    visibleFields,
    variant,
    variantMapping = {},
    displayMode,
    ...restProps
  } = props;
  const ownerState = {
    displayMode,
    item,
    visibleFields,
    variant,
    variantMapping,
    ...restProps
  };
  const Component = (typeof variantMapping === "function" ? variantMapping(ownerState, defaultVariantMapping) : variantMapping[variant]) || defaultVariantMapping(ownerState);
  return /* @__PURE__ */jsx(Component, {
    item,
    visibleFields,
    ...restProps
  });
}
export { PostsModuleItem as default };